// extracted by mini-css-extract-plugin
export default {"icon-close":"imageViewer_icon-close__elYUB"};